import { HTTPError } from "ky";
import { AjaxError } from "../ajax-error";

export class UnauthorizedException extends AjaxError {
  constructor(
    response: Response,
    request: Request,
    options: HTTPError["options"]
  ) {
    super(401, response, request, options);
    this.name = "UnauthorizedException";
  }

  getUserFriendlyMessage(): string {
    return this.message || "Non sei autorizzato. Effettua nuovamente il login.";
  }
}